'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _TypeEditor = require('./TypeEditor');

var _TypeEditor2 = _interopRequireDefault(_TypeEditor);

var _reactFulcrum = require('@upgrowth/react-fulcrum');

var _TypeContext = require('./TypeContext');

var _Layout = require('../layouts/Layout');

var _Layout2 = _interopRequireDefault(_Layout);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ensure = function ensure(val) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "string";
  var otherwise = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === type ? val : otherwise;
};

var ObjectEditor = (0, _TypeContext.withTypes)(function (_ref) {
  var name = _ref.name,
      type = _ref.type,
      context = _ref.context,
      resolveType = _ref.resolveType;
  var label = type.label,
      description = type.description,
      _type$defaultValue = type.defaultValue,
      defaultValue = _type$defaultValue === undefined ? {} : _type$defaultValue,
      _type$variant = type.variant,
      variant = _type$variant === undefined ? "none" : _type$variant,
      layout = type.layout;
  var value = context.value,
      current = context.current,
      path = context.path;
  value = (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === "object" ? value : defaultValue;
  current = (typeof current === 'undefined' ? 'undefined' : (0, _typeof3.default)(current)) === "object" ? current : {};
  return _react2.default.createElement('div', {
    className: 'ObjectEditor variant-' + variant
  }, _react2.default.createElement(_Layout2.default, {
    layout: layout,
    values: (0, _lodash.map)(type.of, function (childType, name) {
      childType = resolveType(childType);
      var _childType = childType,
          _childType$label = _childType.label,
          label = _childType$label === undefined ? name : _childType$label,
          description = _childType.description;
      return {
        key: name,
        type: childType,
        dirty: (0, _Layout.isDirty)((0, _lodash.get)(value, [name]), (0, _lodash.get)(current, [name])),
        label: label,
        el: _react2.default.createElement(_reactFulcrum.Field, {
          key: name,
          name: name,
          label: ensure(label),
          description: ensure(description)
        }, _react2.default.createElement(_TypeEditor2.default, {
          name: name,
          type: childType,
          context: (0, _extends3.default)({}, context, {
            path: [].concat((0, _toConsumableArray3.default)(path), [name]),
            value: value[name],
            current: current[name]
          })
        }))
      };
    })
  }));
});
exports.default = ObjectEditor;